module.exports = __webpack_public_path__ + "static/media/voucher.3dbac144.svg";